import React from 'react'
import flowRight from 'lodash/flowRight'

import withDialog, { WrappedProps } from 'shared/hocs/withDialog'
import { ConfirmationType } from 'shared/components/Notes/models/confirmation'
import TextField, { FieldLabel } from 'shared/components/TextField'
import styled from 'styled-components'
import Box from 'shared/components/Box'

type Props = WrappedProps<ConfirmationType> & {
  label?: string
  description?: string
  isFlag?: boolean
}

function ActionConfirmationDialog(props: Props) {
  const { formState, formHandlers, label = 'Message', description = '', isFlag = false } = props
  const { fields, errors } = formState
  const { onElementChange, onChange } = formHandlers

  return (
    <ActionConfirmationDialogBodyContainer className="confirm-dialog-container">
      {description && <Box className="description">{description}</Box>}
      <Box>
        <FieldLabel>{label}</FieldLabel>
        <TextField
          id="message"
          placeholder="Write your reason here"
          maxRows={3}
          rows={3}
          value={fields.message}
          onChange={onElementChange}
          error={Boolean(errors.message)}
          errorText={errors.message}
          disabled={false}
        />
      </Box>
    </ActionConfirmationDialogBodyContainer>
  )
}

const WrappedActionConfirmationDialog = flowRight(withDialog())(ActionConfirmationDialog)

const ActionConfirmationDialogBodyContainer = styled(Box)`
  color: ${({ theme }) => theme.colors.secondary};
  padding: 40px 40px 0;
  width: 100%;
  max-width: 540px;

  .description {
    width: 100%;
    margin-bottom: 40px;
    text-align: center;

    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
  }
`

WrappedActionConfirmationDialog.defaultProps = {
  continueIsDisabled(data: ConfirmationType) {
    return !data?.message?.length
  },
}

export default WrappedActionConfirmationDialog
